import { OnUniverseClick } from './universes.types'

export const UNIVERSE_CLICK = 'UNIVERSE_CLICK'

export const onUniverseClick: OnUniverseClick = payload => ({
  payload,
  type: UNIVERSE_CLICK
})
